define([
	"dojo/_base/declare",
	"csi/reflection",
	"csi/table/Copy",
	"csi/xml"
], function(declare,reflection,Copy,xml) {

	var FOODSOURCE_ADD_SAMPLE = "FoodSourceAddSample";
	var FORMULATEDPRODUCT = "FormulatedProduct";
	var SAMPLEURL = "SampleURL";
	var URL = "URL";

	return declare(Copy, {
		idOwnerRelation: "Samples",
		/**
		 * @override
		 * When copying Sample make sure to blank out Sample Field
		 */
		getFormData: function () {
			var fd = this.inherited(arguments);
			fd.setFieldInitialValue(xml.ATTR_NAME, "");
			return fd;
        },

		/**
		 * @override
		 * Add path to access factory node since its not in cache 
		 */
		onDependencyPaths(paths) {
			paths.push("Child:SampleFactory");
		},

		_toWriterParent: function() {
			var owner = this.idOwnerRelation ? this.m_cache.getNode(this.urlOwnerParent, true) : null;
			const sampleName = this.generateSampleName();
			if (owner) {
				var	relation = reflection.getRelation(owner, this.idOwnerRelation);
				if (relation) {
					var parent = this.getParent();
					this.m_writer.callMethod(FORMULATEDPRODUCT, FOODSOURCE_ADD_SAMPLE)
						.addParameter(URL, xml.ATTR_REF, this.urlOwnerParent)
						.addParameter(SAMPLEURL, xml.ATTR_REF, this.m_value)
						.addParameter("Name", xml.ATTR_STRING, sampleName);

				}
			}
		},

		generateSampleName(){
			const { m_cache } = this;
			const fd = this.m_formData;
			const owner = this.idOwnerRelation ? m_cache.getNode(this.urlOwnerParent, true) : null;
			const sourceURL = xml.isValidURL(owner.SupplierFactory);
			const sample = this.m_nodeSource;
			const factoryURL = sample.SampleFactory;
			const factoryNode = m_cache.getNode(factoryURL);
			const sourceNode = sourceURL ? factoryNode : m_cache.getNode(owner.Supplier);
			const sourceName = sourceNode?.$Name;
			const sampleName = fd.getFieldValue(xml.ATTR_NAME) == "" ? sourceName : fd.getFieldValue(xml.ATTR_NAME, true) + " - " + sourceName;

			return sampleName;
		},

	});
});